import axios from "axios";

export default{
    methods:{
        downloadWithVueResource(download_file) {
            axios({
              url: download_file.url,
              method: "GET",
              responseType: "blob"
            }).then(response => {
              var fileURL = window.URL.createObjectURL(new Blob([response.data]));
              var fileLink = document.createElement("a");
      
              fileLink.href = fileURL;
              fileLink.setAttribute("download", `${download_file.title}.pdf`);
              document.body.appendChild(fileLink);
      
              fileLink.click();
            });
          }
    }
}